import { render, staticRenderFns } from "./dealerstatistics.vue?vue&type=template&id=4ee7dc1f&"
import script from "./dealerstatistics.vue?vue&type=script&lang=js&"
export * from "./dealerstatistics.vue?vue&type=script&lang=js&"
import style0 from "./dealerstatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports